import logo from './logo.svg';
import './App.css';
import MapView from "./MapView";

function App() {
  return <MapView />;
}

export default App;
